import React, {useState, useEffect} from 'react';
import {useTranslation} from "react-i18next";

const AnimatedCounter = ({value, className = "", enableEffect, ptsClass = "text-xs"}) => {

    const {t} = useTranslation();
    const [displayValue, setDisplayValue] = useState(value);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (value === displayValue) return;

        let startTimestamp = null;
        const duration = 1500;
        const startValue = displayValue;

        if (enableEffect) setIsAnimating(true);

        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            setDisplayValue(Math.floor(progress * (value - startValue) + startValue));

            if (progress < 1) {
                window.requestAnimationFrame(step);
            } else {
                if (enableEffect) setTimeout(() => setIsAnimating(false), 200);
            }
        };
        window.requestAnimationFrame(step);
    }, [value]);

    return (
        <span
            className={`inline-block transition-all duration-300 origin-center ${className} ${
                isAnimating ? 'text-yellow-500 scale-125 font-black drop-shadow-sm z-20' : ''
            }`}
        >
            {displayValue}
            <span className={`ml-1 opacity-80 font-bold ${ptsClass}`}>
                {t('common.points')}
            </span>
        </span>
    );
};

export default AnimatedCounter;